import { DateTime } from 'luxon';
import { InspectionModel, ProtocolItemModel } from 'shared/domain/inspection/inspectionModel';
import { getProtocolItemEkComment } from 'shared/domain/inspection/protocolItemAccessors';
import { InspectionOutDto, ProtocolOutDtoWithChecklistId } from 'shared/dtos/out/inspection';
import { ObjectIdString } from 'helpers/idComparison';
import { Identificable } from 'shared/types/commonView';

export type InspectionSubmitFormFields = {
  inspectionDate?: string | DateTime | null;
  workTypes?: Identificable<ObjectIdString>[];
  levels?: Identificable<ObjectIdString>[];
  comment?: string;
  controlledParty?: Identificable<ObjectIdString>[];
  contracts?: Identificable<ObjectIdString>[];
  sites?: Identificable<ObjectIdString>[];
};

function hasIssues(protocol: InspectionModel['protocol']): boolean {
  return protocol.some(
    (protocolItem) => protocolItem.complianceCheck.issues.length
  );
}

export function toInspectionOutDto(
  inspection: InspectionModel | undefined,
  form: InspectionSubmitFormFields
): Partial<InspectionOutDto> {
  const inspectionDate = DateTime.isDateTime(form.inspectionDate)
    ? (form.inspectionDate.toISO() ?? undefined)
    : typeof form.inspectionDate === 'string'
      ? form.inspectionDate
      : undefined;

  if (inspection && hasIssues(inspection.protocol)) {
    return {
      inspectionDate,
      workTypes: form.workTypes?.map((element) => element._id),
      levels: form.levels?.map((element) => element._id),
      comment: form.comment,
      controlledParty: form.controlledParty?.map((element) => element._id),
      contracts: form.contracts?.map((element) => element._id),
    };
  }

  return {
    inspectionDate,
    workTypes: form.workTypes?.map((element) => element._id),
    sites: form.sites?.map((element) => element._id),
    levels: form.levels?.map((element) => element._id),
    comment: form.comment,
    controlledParty: form.controlledParty?.map((element) => element._id),
    contracts: form.contracts?.map((element) => element._id),
  };
}

export function filterUnchangedProtocolItems(
  inspectionModel: InspectionModel | undefined,
  protocolItems: ProtocolOutDtoWithChecklistId[]
): ProtocolOutDtoWithChecklistId[] {
  if (!inspectionModel) {
    return protocolItems;
  }

  const protocolModelMap = new Map<string, ProtocolItemModel>();
  inspectionModel.protocol.forEach((protocolItemModel) => {
    protocolModelMap.set(
      protocolItemModel.templateChecklistItem,
      protocolItemModel
    );
  });

  return protocolItems.filter((protocolItem) => {
    const matchedItem = protocolModelMap.get(protocolItem.checklistId);
    if (!matchedItem) {
      return true;
    }

    if (
      getProtocolItemEkComment(matchedItem) ===
      getProtocolItemEkComment({ complianceCheck: protocolItem.complianceCheck })
    ) {
      return false;
    }

    return true;
  });
}
